import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFrown } from '@fortawesome/pro-regular-svg-icons/faFrown'

export const UnauthorisedMessageContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 4rem;
    padding-bottom: 4rem;
    height: 100%;

    p {
        font-size: 1.1rem;
    }
`

const UnauthorisedMessage = ({
    url = '/',
    message = 'You do not have permission to view this page',
    buttonLabel = 'Go to Dashboard',
}) => (
    <UnauthorisedMessageContainer data-testid="unauthorised-message">
        <FontAwesomeIcon icon={faFrown} size="6x" className="!mb-4" />
        <p>{message}</p>

        <Link to={url} className="btn btn-primary">
            {buttonLabel}
        </Link>
    </UnauthorisedMessageContainer>
)

export default UnauthorisedMessage
